














































import {Component, Vue, Prop, Model, Watch} from 'vue-property-decorator';
import {SelectionListGroupingModel} from './interfaces';

@Component({})
export default class SelectionListGroupingMenu extends Vue {
  // Ключ для перерисовки
  key = 0;

  // Тултип кнопки группировки
  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  // Заголовок группировки
  @Prop({required: true, type: String, default: ''})
  caption!: string;

  // Иконка кнопки группировки
  @Prop({required: true, type: String})
  icon!: string;

  // Список группировок
  @Prop({required: true, type: Array})
  groupings!: SelectionListGroupingModel[];

  // Статус применения группировки (нужен для отрисовки кнопки)
  @Prop({required: true})
  applyStatus!: boolean;

  // Показатель того, что кнопка отключена
  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({default: () => ({})})
  activators!: {};

  // Модель для меню (открыто\закрыто)
  menu = false;

  @Model('change')
  selectedGroupingValue!: SelectionListGroupingModel | null;

  get selectedGrouping() {
    return this.selectedGroupingValue;
  }

  set selectedGrouping(newSelectedGroupingValue: SelectionListGroupingModel | null) {
    if (newSelectedGroupingValue) {
      this.$emit('change', newSelectedGroupingValue);
      this.$emit('select');
    }
    this.menu = false;
  }

  @Watch('menu')
  onMenu(value: boolean) {
    if (!value) this.key++;
  }

  created() {
    this.groupings.sort((x: any, y: any) => y.name.localeCompare(x.name));
  }
}
